import React from 'react';
import PropTypes from 'prop-types';
import { LinkElement } from '@els/els-react--link-element';

function SubstancePubChemReferences({ references }) {
  if (!references) {
    return null;
  }

  const referenceKeys = Object.keys(references);
  if (!referenceKeys || referenceKeys.length === 0) {
    return null;
  }

  return (
    <>
      {referenceKeys.map((title) => (
        <LinkElement key={title} href={references[title]} isExternal>
          <span>{title}</span>
        </LinkElement>
      ))}
    </>
  );
}

SubstancePubChemReferences.propTypes = {
  references: PropTypes.array.isRequired,
};

export default SubstancePubChemReferences;
